import type { Agent } from '../types';

export type AgentRole = 'coordinator' | 'sub-agent' | 'standalone';

/**
 * Computes the role(s) of each agent based on sub-agent relationships.
 * An agent can have multiple roles (e.g. both coordinator and sub-agent).
 */
export function computeAgentRoles(agents: Agent[]): Map<string, Set<AgentRole>> {
  // Collect all agent IDs referenced as sub-agents
  const referencedIds = new Set<string>();
  for (const agent of agents) {
    if (agent.subAgentIds) {
      for (const id of agent.subAgentIds) {
        referencedIds.add(id);
      }
    }
  }

  // Classify each agent
  const roles = new Map<string, Set<AgentRole>>();
  for (const agent of agents) {
    const agentRoles = new Set<AgentRole>();

    if (agent.subAgentIds && agent.subAgentIds.length > 0) {
      agentRoles.add('coordinator');
    }

    if (referencedIds.has(agent.agentId)) {
      agentRoles.add('sub-agent');
    }

    if (agentRoles.size === 0) {
      agentRoles.add('standalone');
    }

    roles.set(agent.agentId, agentRoles);
  }

  return roles;
}
